import PropTypes from "prop-types"
import React from "react"
import Helmet from "react-helmet"
import { getPageMeta } from "../scripts/utils"
import LoginLogo from "./elements/LoginLogo"
import { getAccountSettings } from "../scripts/accountSettings"
import { getStyles, getStyleTag } from "../styles/dynamicStyles"
import Image from "./elements/Image"
import { injectIntl } from "react-intl"
import settingsMessages from "../messages/settings"
class LoginLayout extends React.Component {
  static propTypes = {
    main: PropTypes.node.isRequired,
    right: PropTypes.node
  }

  render() {
    const {
      name: title,
      settings: {
        style: { header: styleHeaderType }
      },
      sign_in_background_image: signInBackgroundImage,
      og_image: ogImage
    } = getAccountSettings(
      this.props.intl.formatMessage(settingsMessages.authenticAccountId)
    )

    return (
      <div
        data-componant="LoginLayout"
        className="p-offpage"
        style={getStyles("p-offpage")}
      >
        {getStyleTag([
          "p-offpage",
          "p-offpage__container",
          "p-offpage__background",
          "p-offpage__main-content",
          "p-offpage__main-content--skinny"
        ])}
        {signInBackgroundImage &&
          signInBackgroundImage.url && (
            <style
              dangerouslySetInnerHTML={{
                __html: `
            .p-offpage__background:before  { 
              background-image: url(${signInBackgroundImage.url});
            }
          `
              }}
            />
          )}
        <div
          className="p-offpage__background"
          style={getStyles("p-offpage__background")}
        >
          &nbsp;
        </div>
        <Helmet
          title={title}
          titleTemplate={`%s - ${title}`}
          meta={getPageMeta({
            title,
            image: ogImage ? ogImage.url : null
          })}
        />
        <div
          className="p-offpage__container"
          style={getStyles("p-offpage__container")}
        >
          <div
            className="p-offpage__inner"
            style={getStyles("p-offpage__inner")}
          >
            <div className="row" style={getStyles("p-offpage__inner__row")}>
              <div
                className="small-12 columns"
                style={getStyles("p-offpage__inner__row__column")}
              >
                <header
                  className={`p-offpage__header clearfix ${styleHeaderType}`}
                >
                  <div className="pull-left">
                    <LoginLogo />
                  </div>
                  {styleHeaderType === "default" &&
                    this.props.right && (
                      <div className="pull-right">{this.props.right}</div>
                    )}
                </header>

                <section
                  className="p-offpage__main-content p-offpage__main-content--skinny"
                  style={getStyles("p-offpage__main-content--skinny")}
                >
                  {styleHeaderType === "default" && (
                    <Image
                      className="p-offpage__border"
                      src="/images/offpage-border.png"
                      alt="Vintage border"
                    />
                  )}
                  {this.props.main}
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(LoginLayout)



// WEBPACK FOOTER //
// ./webapp/components/LoginLayout.js